import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../../misc.module';
import { SchoolDetailViewPageRoutingModule } from './view-routing';
import { SchoolDetailViewPageComponent } from './view.page';

@NgModule({
  declarations: [SchoolDetailViewPageComponent],
  imports: [FormsModule, IonicModule, SchoolDetailViewPageRoutingModule, MiscModule, CommonModule]
})
export class SchoolDetailViewPageModule {}
